<template>
  <div class="add-product" v-loading="fullscreenLoading">
    <div ref="headsection" class="head-section">
      <div style="width: 100%;height: 35px">
        <div class="crumbs-navigation" style="width: 40%;float:left">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/main' }">
              我的报价单
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <a @click="toSecond">产品配置组</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item> 添加产品</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="tab-p" style="width: 60%;float: right">
          <div class="tab-b">
            <a>添加产品</a>
            <a @click="added">已添加产品</a>
            <div class="clearfloat" />
          </div>
        </div>
      </div>
      <div class="clearfloat" />
      <el-form ref="form" :model="form" :inline="true" label-width="auto">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="typeOptions">
              <el-select
                v-model="type"
                :loading="loading"
                value-key="seriesId"
                @change="handleTypeChange"
                style="width: 120px;"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item prop="productLine">
              <el-select
                v-model="form.productLine"
                filterable
                clearable
                placeholder="点选产品线"
                :loading="loading"
                value-key="lineId"
                @change="onProdLineChange"
                @clear="clearLine"
              >
                <el-option
                  v-for="item in allProdLines"
                  :key="item.lineId"
                  :label="item.lineName"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item prop="productCategories">
              <el-select
                v-model="form.productCategories"
                filterable
                clearable
                reserve-keyword
                placeholder="点选产品大类"
                :loading="loading"
                value-key="categoryId"
                @change="onProductCategoriesChange"
                @clear="clearCategories"
                style="width: 180px;"
              >
                <el-option
                  v-for="item in allProductCategories"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item"
                >
                  <span style="font-weight: bold">{{
                    "[产品大类]：" + item.categoryName
                  }}</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    "[产品线]：" + item.lineName
                  }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item prop="productSeries">
              <el-select
                v-model="form.productSeries"
                filterable
                clearable
                reserve-keyword
                placeholder="点选产品系列"
                :loading="loading"
                value-key="seriesId"
                @change="handleChange"
                style="width: 180px;"
              >
                <el-option
                  v-for="item in allProductSeries"
                  :key="item.seriesId"
                  :label="item.seriesName"
                  :value="item"
                >
                  <span style="font-weight: bold">{{
                    "[产品系列]：" + item.seriesName
                  }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    "[产品大类]：" + item.categoryName
                  }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    "[产品线]：" + item.lineName
                  }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>&nbsp;</el-form-item>
            <el-form-item prop="keys">
              <el-select
                v-model="form.keys"
                filterable
                clearable
                reserve-keyword
                placeholder="模糊点选主机"
                @change="getHosts"
              >
                <el-option
                  v-for="item in hostList"
                  :key="item.productCode"
                  :label="item.productName"
                  :value="{value:item.productCode,label:item.productName}"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              &nbsp;<el-button type="primary" @click="seachForm()">
                      搜索
                    </el-button>&nbsp;
              <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24" align="right">
            <span
              v-if="!configurationGroup.isService"
              class="my-collect"
              @click="openUserCollection"
            ><i class="el-icon-star-on" />我的收藏</span>
            <el-button type="primary" @click="createProductGroupSubItem">
              添加产品至配置组
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="weakCorrelationFlg" style="color: red;margin-bottom:5px;text-align:left ">{{ weakCorrelation }}</div>
    <AddProductTable
      ref="addProductTable"
      :data="ProductInitListVO"
      :configuration-group="configurationGroup"
      @load="load"
    />
    <shoppingCart
      ref="mychild"
      :configuration-group="configurationGroup"
    />
    <UserCollection
      ref="myCollection"
      :configuration-group="configurationGroup"
    />
  </div>
</template>

<script>
// xe-utils 函数库
import XEUtils from 'xe-utils';
import api from '../../api';
import longText from '../quotationlist/longText';
import eventBus from '@/utils/eventBus';
import {
  setStore,
  getStore,
  removeStore,
  isControlled,
  isNewProduct
} from '@/utils/mUtils';
import { productPriceFormat, changeStyle } from '@/utils/numberFormater';
import shoppingCart from './shoppingCart';
import ProductNameFormation from '../components/ProductNameFormation';
import ProductOperate from '../components/ProductOperate';
import UserCollection from './UserCollection';
import AddProductTable from '../components/AddProductTable';
import { changeType } from '@/mixins/changeType';
export default {
  name: 'AdditionProduct',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    longText,
    shoppingCart,
    // eslint-disable-next-line vue/no-unused-components
    ProductNameFormation,
    UserCollection,
    // eslint-disable-next-line vue/no-unused-components
    ProductOperate,
    AddProductTable
  },
  mixins: [changeType],
  data () {
    return {
      search: '',
      tableHeight: 350,
      isLoadTbale: false,
      // username: getStore("username"),
      formLabelWidth: '120px',
      dialogFormVisible: false,
      configurationGroup: {
        projectId: '',
        groupId: '',
        groupName: '',
        isService: false
      },
      groupNameT: '',
      form: {
        productLine: '',
        productCategories: '',
        productSeries: '',
        lineProperty: [],
        keys: '',
        hostProductCode: '',
        hostProductName: '',
        preproduction: '',
        stopProduction: '',
        isSpecialControlled: false,
        isProductPackage: false,
        showOpticalModule: false
      },
      hostList: [],
      // 表单验证
      rules: {
        groupName: [
          { required: true, message: '请输入配置组名称', trigger: 'blur' },
          { max: 40, message: '不能超过40个字符' }
        ]
      },
      allProdLines: [],
      allProductCategories: [],
      allProductSeries: [],
      allLinePropertyMap: [],
      // 页数
      page: 1,
      rows: 60,
      total: 0,
      totalDissipation: 0,
      notloading: true,
      ifshow: true,
      fullscreenLoading: false,
      screenWidth: document.body.clientWidth, // 这里是给到了一个默认值 （这个很重要）
      loading: false,
      totalRiilPrice: 0,
      isPartner: true,
      loadflg: true,
      // dialogProductRuleVisible:false,
      productRuleList: [],
      addProductIndexList: [],
      ProductInitListVO: [],
      weakCorrelationFlg: false,
      weakCorrelation: ''
    };
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val;
    }
  },

  methods: {
    productPriceFormat,
    changeStyle,
    isControlled,
    isNewProduct,
    getQuantity () {
      this.$refs.mychild.getProductQuantity();
    },
    openUserCollection () {
      this.$refs.myCollection.openUserCollection();
      this.$refs.myCollection.openPackageCollection();
    },
    toProductQualificationList (productName) {
      let routeData = this.$router.resolve({
        name: 'ProductQualificationList',
        query: { productName: productName }
      });
      window.open(routeData.href, '_blank');
    },
    // 跳转至配置组
    toSecond () {
      // this.$refs.myAddProductRuleList.getAddValidateInfo();
      this.$router.push({
        name: 'CreatOrderSecond/second',
        query: { projectId: this.configurationGroup.projectId }
      });
    },
    // tab 切换 添加产品
    tabAdd () {
      // secondGroupId : row.groupId,secondGroupName:row.groupName
      this.$router.push({
        name: 'AdditionProduct/add',
        params: {
          groupId: this.configurationGroup.groupId,
          projectId: this.configurationGroup.projectId,
          isService: this.configurationGroup.isService
        }
      });
    },
    // tab 切换 已添加产品
    added () {
      this.saveStatus();
      this.$router.push({
        name: 'AddedProduct/added',
        params: {
          groupId: this.configurationGroup.groupId,
          projectId: this.configurationGroup.projectId,
          isService: this.configurationGroup.isService
        },
        query: {
          routerPath: 'PreciseAssociation'
        }
      });
    },
    // 修改配置组名称
    editName () {
      this.configurationGroup.groupName = this.groupNameT;
      this.dialogFormVisible = true;
    },
    updateConfiguration () {
      if (this.configurationGroup.groupName == this.groupNameT) {
        this.dialogFormVisible = false;
        return false;
      }
      this.$refs['configurationGroup'].validate(valid => {
        if (valid) {
          api
            .editConfigurationGroup(this.configurationGroup)
            .then(res => {
              let json = res.data;

              if (json.status === '200') {
                // 修改成功
                this.groupNameT = this.configurationGroup.groupName;
                this.$notify.success('修改配置组名称成功！');
                this.dialogFormVisible = false;
              } else {
                // 修改失败
                this.$notify.error(json.data);
              }
            })
            .catch(() => {
              this.$notify.info('网络异常！');
            });
          // this.dialogFormVisible = false;
        } else {
          this.dialogFormVisible = true;
        }
      });
    },
    // 获取产品线下拉列表
    getProdLineList () {
      api
        .getProductLineList({
          params: { userCollection: '', groupType: this.getGroupType() }
        })
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            // console.log(json.data)
            this.allProdLines = json.data;
            setStore(`AdditionProdLines`, this.allProdLines);
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error('网络异常！');
        });
    },
    // 清空产品线同时清空产品大类，产品系列
    clearLine () {
      // 产品大类
      this.allProductCategories = [];
      this.form.productCategories = '';
      // 产品系列
      this.allProductSeries = [];
      this.form.productSeries = '';
      // 产品分类
      this.allLinePropertyMap = [];
      this.form.lineProperty = [];
      // 清除表格组件数据
      this.$refs.addProductTable.tableData = [];
      this.productInitListVOS = [];
    },
    // 选择产品线改变事件
    onProdLineChange () {
      // 清空产品大类、系列选中值
      this.form.productCategories = '';
      this.form.productSeries = '';
      this.form.lineProperty = [];
      this.getProductCategories();
      // 产品系列
      this.allProductSeries = [];
      this.form.productSeries = '';
      if (
        this.form.productLine != null &&
        this.form.productLine.lineId != null
      ) {
        this.getlineProperty();
      }
      this.getProductSeriesList();
      // 重置主机
      this.form.keys = null;
      this.hostList = [];
      // 清除表格组件数据
      this.$refs.addProductTable.tableData = [];
      this.productInitListVOS = [];
      this.getHostList();
    },
    handleChange () {
      // 重置主机
      this.form.keys = null;
      this.hostList = [];
      this.getHostList();
    },
    // 获取产品大类下拉列表
    getProductCategories () {
      let param = {
        params: {
          lineId: this.form.productLine.lineId,
          userCollection: '',
          groupType: this.getGroupType()
        }
      };
      api
        .getProductCategoriesList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.allProductCategories = json.data;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error('网络异常！');
        });
    },
    // 清空产品大类，同时清空产品系列
    clearCategories () {
      // 重置产品系列列表数据
      this.allProductSeries = [];
      this.form.productSeries = '';
      // 重置主机
      this.form.keys = null;
      this.hostList = [];
      this.onProdLineChange();
    },
    // 选择产品大类改变事件
    onProductCategoriesChange () {
      // 重置产品系列列表数据
      this.allProductSeries = [];
      this.form.productSeries = '';

      // 重置主机
      this.form.keys = null;
      this.hostList = [];
      this.seachForm();
      this.getProductSeriesList();
      this.getHostList();
    },
    // 获取产品系列列表
    getProductSeriesList () {
      let param = {
        params: {
          lineId: this.form.productLine.lineId,
          categoryId: this.form.productCategories.categoryId,
          userCollection: '',
          groupType: this.getGroupType()
        }
      };
      api
        .getProductSeriesList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.allProductSeries = json.data;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error('网络异常！');
        });
    },
    // 获取产品分裂列表
    getlineProperty () {
      let param = {
        params: {
          lineId: this.form.productLine.lineId
        }
      };
      api
        .getlineProperty(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            // console.log(this.allLinePropertyMap);
            this.allLinePropertyMap = json.data;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error('网络异常！');
        });
    },
    // 重置搜索框
    resetForm (formName) {
      this.allProductCategories = [];
      this.allProductSeries = [];
      this.form.keys = null;
      this.hostList = [];
      this.$refs.addProductTable.tableData = [];
      this.allLinePropertyMap = [];
      this.$refs[formName].resetFields();
      removeStore(`AdditionProduct`);
      this.getProdLineList();
      this.getProductCategories();
      this.getProductSeriesList();
      this.getHostList();
    },
    getHostList () {
      let param = {
        'lineID': this.form.productLine.lineId,
        'categoryID': this.form.productCategories.categoryId,
        'seriesID': this.form.productSeries.seriesId
      };
      this.fullscreenLoading = true;
      api.getHostList(param).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.hostList = json.data;
        } else {
          this.$notify.error(json.err);
        }
      })
        .catch(() => {
          // this.fullscreenLoading=false;
          this.$notify.error('网络异常！');
        });
      this.fullscreenLoading = false;
    },
    // 搜索功能
    seachForm () {
      // this.ProductInitListVO = [];
      // this.page = 1;
      // let propertyCode = "";
      // let fieldFatherID = "";
      // if (this.form.lineProperty && this.form.lineProperty.length > 0) {
      //   propertyCode = this.form.lineProperty[0];
      //   if (this.form.lineProperty.length == 2) {
      //     fieldFatherID = this.form.lineProperty[1];
      //   }
      // }
    },
    getHosts (params) {
      const { value, label } = params;
      if (!value && !label) {
        return false;
      }
      this.fullscreenLoading = true;
      this.form.hostProductCode = value;
      this.form.hostProductName = label;
      // 清空数据
      this.ProductInitListVO = [];
      let param = {
        productCode: value,
        productName: label,
        opticalModuleLazy: true
      };
      api
        .initAllRulePreciseCorrelationProductList(param)
        .then(res => {
          this.fullscreenLoading = false;
          let json = res.data;
          if (json.status === '200') {
            this.ProductInitListVO = json.data;
          } else {
            this.$notify.error(json.data);
          }
        })
        .catch(() => {
          this.$notify.info('网络异常！');
          this.fullscreenLoading = false;
        });
      this.getWeakCorrelation2(value);
    },
    // 点击加载更多
    loadingMore () {
      // 数据已全部加载：直接收口为"无更多数据"，不打开遮罩、不发请求
      if (this.total > 0 && this.ProductInitListVO.length >= this.total) {
        this.ifshow = false;
        this.notloading = true;
        return;
      }
      // 加载中 / 保存中：直接返回，避免遮罩被置位后无人复位
      if (!this.loadflg) {
        return;
      }
      this.fullscreenLoading = true;
      this.notloading = false;
      this.loadflg = false;
      this.page += 1;
      let propertyCode = '';
      let fieldFatherID = '';
      if (this.form.lineProperty && this.form.lineProperty.length > 0) {
        propertyCode = this.form.lineProperty[0];
        if (this.form.lineProperty.length === 2) {
          fieldFatherID = this.form.lineProperty[1];
        }
      }
      let param = {
        lineId:
          this.form.productLine !== '' ? this.form.productLine.lineId : '',
        categoryId:
          this.form.productCategories !== ''
            ? this.form.productCategories.categoryId
            : '',
        seriesId:
          this.form.productSeries !== ''
            ? this.form.productSeries.seriesId
            : '',
        propertyCode: propertyCode,
        fieldFatherID: fieldFatherID,
        keys: this.form.keys,
        preproduction: this.form.preproduction,
        stopProduction: this.form.stopProduction,
        isSpecialControlled: this.form.isSpecialControlled,
        isProductPackage: this.form.isProductPackage,
        showOpticalModule: this.form.showOpticalModule,
        page: this.page,
        rows: 60,
        isServiceFlag: this.configurationGroup.isService
      };
      api
        .initProductList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.ProductInitListVO = [
              ...this.ProductInitListVO,
              ...json.data.list
            ];
            this.total = json.data.total;
            this.ifshow = this.ProductInitListVO.length < json.data.total;
          } else {
            this.$notify.error(json.err);
          }
        })
        .catch(() => {
          this.$notify.error('网络异常！');
        })
        .then(() => {
          // 统一收尾：成功/业务错误/网络异常都复位遮罩、忙标志与按钮态
          this.loadflg = true;
          this.fullscreenLoading = false;
          this.notloading = true;
        });
    },
    // 初始加载添加产品列表
    initGetProductList () {
      let param = {
          lineId: '',
          categoryId: '',
          seriesId: '',
          keys: '',
          preproduction: this.form.preproduction,
          stopProduction: this.form.stopProduction,
          isSpecialControlled: this.form.isSpecialControlled,
          isProductPackage: this.form.isProductPackage,
          showOpticalModule: this.form.showOpticalModule,
          page: this.page,
          rows: this.rows,
          isServiceFlag: this.configurationGroup.isService
      };
      this.fullscreenLoading = true;
      api
        .initProductList(param)
        .then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.ProductInitListVO = [
              ...this.ProductInitListVO,
              ...json.data.list
            ];
            this.total = json.data.total;
            this.ifshow = this.ProductInitListVO.length !== json.data.total;
          } else {
            this.$notify.error(json.err);
          }
        }).catch(() => {
          this.$notify.error('网络异常！');
        }).then(() => {
          // 统一收尾：业务错误/网络异常同样复位遮罩
          this.fullscreenLoading = false;
        });
    },
    getGroupType () {
      let groupType = 1;
      if (this.configurationGroup.isService) {
        groupType = 2;
      }
      return groupType;
    },
    // 添加至配置组
    createProductGroupSubItem (productInitList) {
      this.addProductIndexList = [];
      if (this.loadflg) {
        let productInitListVOS = [];
        let productInitVO = {};
        if (productInitList && productInitList.length > 0) {
          productInitListVOS = productInitList;
        } else {
          this.$refs.addProductTable.tableData.forEach((item, index) => {
            if (item.nodeLevel && item.nodeLevel === 1) {
              productInitVO = item.productInitListVO;
              if (productInitVO && productInitVO.purchaseQuantity > 0) {
                productInitListVOS.push(productInitVO);
              }
            }
            if (item.children) {
              item.children.forEach((item2, index) => {
                if (item2.nodeLevel && item2.nodeLevel === 2) {
                  if (item2.children) {
                    item2.children.forEach((item3, index) => {
                      if (item3.nodeLevel && item3.nodeLevel === 2) {
                        if (item3.children) {
                          item3.children.forEach((item4, index) => {
                            if (item4.productInitListVO.purchaseQuantity > 0) {
                              productInitListVOS.push(item4.productInitListVO);
                              // this.addProductIndexList.push(index);
                            }
                          });
                        }
                      } else {
                        if (item3.productInitListVO.purchaseQuantity > 0) {
                          productInitListVOS.push(item3.productInitListVO);
                          // this.addProductIndexList.push(index);
                        }
                      }
                    });
                  }
                }
              });
            }
          });
        }
        // return false;
        if (productInitListVOS != null && productInitListVOS.length > 0) {
          this.loadflg = false;
          this.fullscreenLoading = true;
          let body = {
            groupId: this.configurationGroup.groupId,
            productInitListVOS: productInitListVOS,
            productInitVO: productInitVO,
            typeOptions: 2
          };

          api.createProductGroupSubItem(body)
            .then(res => {
              let json = res.data;
              if (json.status === '200') {
                // 跳转到已添加产品
                this.$notify.success('添加至配置组成功！');
                // this.clearProductList();
                this.$refs.mychild.getProductQuantity();
              } else {
                this.$notify.error(json.err);
              }
              this.fullscreenLoading = false;
              this.loadflg = true;
            })
            .catch(() => {
              this.loadflg = true;
              this.fullscreenLoading = false;
              this.$notify.error('网络异常！');
            });
        } else {
          this.loadflg = true;
          this.$message({
            showClose: true,
            duration: 800,
            message: '您没有选择任何产品!',
            type: 'error'
          });
          // this.$notify.error("您没有选择任何产品！");
        }
      }
    },
    clearProductList () {
      if (this.addProductIndexList.length > 0) {
        this.addProductIndexList.forEach(item => {
          this.ProductInitListVO[item].purchaseQuantity = 0;
        });
      }
    },
    getWeakCorrelation2 (productCode) {
      this.weakCorrelation = '';
      this.weakCorrelationFlg = false;
      api.getWeakCorrelation({ params: { 'productCode': productCode } }).then((res) => {
        let json = res.data;
        if (json.status === '200' && json.data != null) {
          this.weakCorrelationFlg = true;
          this.weakCorrelation = json.data.configurationadvice;
        }
      }).catch((e) => {
        console.log(e);
        this.$notify.error('网络异常');
      });
    },

    productDesc (val) {
      let cont = '';
      if (this.screenWidth <= 1440) {
        cont = val.length > 20 ? val.substring(0, 20) : val;
        return cont;
      } else {
        cont = val.length > 35 ? val.substring(0, 35) : val;
        return cont;
      }
    },
    changText (row) {
      if (row.ifShow === undefined) {
        this.$set(row, 'ifShow', true);
      } else {
        row.ifShow = !row.ifShow;
      }
    },
    numberChange (index) {
      if (this.ProductInitListVO[index].purchaseQuantity === undefined) {
        this.$set(this.ProductInitListVO[index], 'purchaseQuantity', 1);
        this.$nextTick(() => {
          this.ProductInitListVO[index].purchaseQuantity = 0;
        });
      }
    },
    foo (h, { column }) {
      if (column.label) {
        return h('span', {}, [
          h('span', [column.label]),
          h(
            'button',
            {
              attrs: {
                style:
                  'float:right;background:rgba(54,186,226,0.6);color:#ffffff;border:none;border-radius:5px;height:2rem'
              },
              on: {
                click: () => {
                  this.expandDiscribe();
                }
              }
            },
            ['全部展开或关闭']
          )
        ]);
      }
    },
    getRiilPrice () {
      if (this.totalRiilPrice == 0) {
        api.getRiilProductTotalPriceByProjectId(
            this.configurationGroup.projectId
          ).then(res => {
            let json = res.data;
            if (json.status === '200') {
              this.totalRiilPrice = json.data;
            }
          });
      }
    },
    saveStatus () {
      let param = {
        params: {
          productLine: this.form.productLine !== '' ? this.form.productLine : '',
          productCategories:
            this.form.productCategories !== ''
              ? this.form.productCategories
              : '',
          productSeries:
            this.form.productSeries !== '' ? this.form.productSeries : '',
          lineProperty:
            this.form.lineProperty && this.form.lineProperty.length > 0
              ? this.form.lineProperty
              : [],
          keys: this.form.keys,
          preproduction: this.form.preproduction,
          stopProduction: this.form.stopProduction,
          isSpecialControlled: this.form.isSpecialControlled,
          isProductPackage: this.form.isProductPackage,
          showOpticalModule: this.form.showOpticalModule,
          page: this.page,
          rows: this.rows,
          isServiceFlag: this.configurationGroup.isService
        }
      };
      setStore(`AdditionProduct`, param);
    },
    initData (param) {
      let lineList = JSON.parse(getStore(`AdditionProdLines`));
      if (lineList) {
        this.allProdLines = lineList;
      } else {
        this.getProdLineList();
      }
      if (param) {
        let obj = JSON.parse(param);
        if (obj.params.productLine) {
          this.form.productLine = obj.params.productLine;
          if (obj.params.lineProperty) {
            this.getlineProperty();
            this.form.lineProperty = obj.params.lineProperty;
          }
        }
        this.getProductCategories();
        this.form.productCategories = obj.params.productCategories;
        if (obj.params.productCategories) {
          this.getProductSeriesList();
          this.form.productSeries = obj.params.productSeries;
        }
      } else {
        // this.getProdLineList();
        this.getProductCategories();
        this.getProductSeriesList();
        // this.initGetProductList();
      }
      this.getHostList();
    },
    scollHeight () {
      let screenH = document.body.clientHeight;
      let headS = this.$refs.headsection.offsetHeight;
      // console.log("document.body.clientHeight;",document.body.clientHeight);
      this.tableHeight = screenH - headS - 100;
      this.isLoadTbale = true;
    },
    load (tree, treeNode, resolve) {
      let param = {
        productCode: this.form.hostProductCode,
        productName: this.form.hostProductName,
        nodeId: tree.nodeId,
        nodeName: tree.nodeName,
        opticalModule: tree.opticalModule,
        nodeLevel: tree.nodeLevel
      };
      api.initRulePreciseCorrelationProductList(param)
        .then(res => {
          let json = res.data;
          treeNode.loaded = true;
          treeNode.loading = false;
          if (json.status === '200') {
            tree.children = json.data;
            XEUtils.eachTree(this.ProductInitListVO, item => {
              if (item.nodeId === tree.nodeId) {
                item.children = json.data;
                return false;
              }
            });
            resolve(json.data);
          } else {
            this.$notify.error(json.data);
          }
        })
        .catch(() => {
          this.$notify.info('网络异常！');
        });
    }
  },

  mounted () {
    this.scollHeight();
    this.groupNameT = this.$route.params.groupName;
    this.configurationGroup.groupId = this.$route.params.groupId;
    this.configurationGroup.projectId = this.$route.params.projectId;
    if (this.$route.params.isService === 'true') {
      this.configurationGroup.isService = true;
    } else if (this.$route.params.isService === 'false') {
      this.configurationGroup.isService = false;
    } else {
      this.configurationGroup.isService = this.$route.params.isService;
    }
    if (
      this.$route.params.routerPath &&
      this.$route.params.routerPath === 'AddedProduct'
    ) {
      this.initData(getStore(`AdditionProduct`));
    } else {
      this.getProdLineList();
      this.getProductCategories();
      this.getProductSeriesList();
      this.getHostList();
    }
    this.getQuantity();
    eventBus.$on('seachForm', () => {
      this.seachForm();
    });
  },
  destroyed () {
    eventBus.$off('seachForm');
  }
};
</script>
<style lang="scss">
  @import "../../styles/product-common.css";
  .add-product {
    .el-table__expand-icon {
      .el-icon-arrow-right:before {
        content: "\e6d9"
      }
    }
    .el-table__expand-icon--expanded {
      transform: rotate(0deg);
      .el-icon-arrow-right:before {
        content: "\e6d8"
      }
    }
  }

  .add-product .table {
    margin-top: 0;
    margin-bottom: 0;
  }

  .add-product .head-section {
    height: 120.2px;
    padding-bottom: 2px;
  }

  .add-product .table .grid-content {
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #36bade;
    background: rgba(54, 186, 222, 0.2);
    vertical-align: middle;
    cursor: pointer;
    margin-bottom: 1px;
  }

  .add-product .table .grid-content .icon {
    margin-right: 6px;
    font-size: 12px;
  }
  .add-product .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8 !important;
    border-color: #60c8e8 !important;
  }
  .clear {
    clear: both;
  }
  .add-product .el-form-item {
    float: left;
    margin-right: 0;
    margin-bottom: 0;
    height: 3rem;
  }
  .add-product .table .el-table .cell {
    white-space: normal;
  }
  /*设置描述*/
  .add-product .cell:hover .el-tag {
    border: 1px solid #36bade;
  }
  .add-product .el-tag {
    text-overflow: ellipsis;
    display: inline-block;
    border: transparent;
    margin: 0;
    cursor: pointer;
  }

  .add-product .el-tag img {
    width: 24px;
  }

  .add-product .dialog-footer {
    margin-top: 20px;
    text-align: center;
  }
  .add-product .head-section el-icon-edit-outline {
    vertical-align: middle;
  }
  .el-table__body-wrapper {
    overflow-y: auto !important;
  }
  @media screen and (max-width: 1366px) {
    .add-product table * {
      margin: 0;
      padding: 0;
    }
    .add-product .tab-p {
      margin-top: 0;
    }
    .add-product .table {
      margin-bottom: 0;
    }
  }
  .checked {
    /*width: 115px;*/
    background: #00a0e9;
    margin: 0 auto;
    /*color: red;*/
  }
</style>
